import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Los canales por los que vende un comercio (códigos de `CANALES` del núcleo). */
export const CANALES_DEF: { codigo: string; nombre: string; detalle: string; fijo?: boolean }[] = [
  { codigo: 'PORTAL', nombre: 'Portal del comercio', detalle: 'Donde entra el comercio a administrar su negocio.', fijo: true },
  { codigo: 'LINK_PAGO', nombre: 'Link de pago', detalle: 'Vende en línea: el cliente acepta y paga desde su teléfono.' },
  { codigo: 'INTEGRACION', nombre: 'Integración por API', detalle: 'Su sistema de caja vende por la pasarela de CrediTotal.' },
  { codigo: 'TIENDA_EN_LINEA', nombre: 'Tienda en línea', detalle: 'Su tienda web cobra con CrediTotal.' },
];

/** Canales que van marcados aunque no se muestren (Juan, 2026-10-19: «vender como cajero no es una modalidad»). */
export const CANALES_SIEMPRE = ['CAJA'];

/** La lista como se guarda: siempre con PORTAL y los ocultos, sin repetidos, en el orden del catálogo. */
export const normalizarCanales = (c: string[] | null | undefined): string[] => {
  const marcados = new Set([...(c || []), 'PORTAL', ...CANALES_SIEMPRE]);
  return [...CANALES_DEF.map((d) => d.codigo), ...CANALES_SIEMPRE].filter((k) => marcados.has(k));
};

/**
 * El selector de «Canales de venta» (Juan, 2026-10-23: lo marca el ejecutivo comercial, antes de los
 * contactos; el gerente puede cambiarlo). Es la pieza que antes vivía en «Cargar las condiciones». No guarda:
 * emite la lista y quien la hospeda la manda a `PUT /workflows/solicitudes/:id/canales`.
 */
@Component({
  selector: 'app-canales-venta',
  templateUrl: './canales-venta.component.html',
  styleUrls: ['./canales-venta.component.css'],
})
export class CanalesVentaComponent {
  @Input() canales: string[] = [];
  @Output() canalesChange = new EventEmitter<string[]>();

  readonly DEF = CANALES_DEF;

  tiene = (codigo: string): boolean => this.canales.includes(codigo);

  alternar(c: { codigo: string; fijo?: boolean }): void {
    if (c.fijo) return;
    const nuevo = this.tiene(c.codigo) ? this.canales.filter((x) => x !== c.codigo) : [...this.canales, c.codigo];
    this.canales = normalizarCanales(nuevo);
    this.canalesChange.emit(this.canales);
  }

  get nombres(): string {
    return this.DEF.filter((d) => this.tiene(d.codigo)).map((d) => d.nombre).join(' · ');
  }

  get pideTecnico(): boolean { return this.tiene('INTEGRACION') || this.tiene('TIENDA_EN_LINEA'); }
  get pideVendedor(): boolean { return this.tiene('LINK_PAGO'); }
}
